(() => {
  const cloneAttr = 'data-ag-pdp-wishlist-clone';
  const cloneClass = 'ag-pdp-wishlist-btn';
  const originalSelector = '[id*="advanced_wishlist_wishlist_btn"] a.wishlist-btn';
  const targetSelector = '.product-info .product-actions-add-to-cart';

  const heartSvg = `
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
         <path d="M1.6665 7.91668C1.66652 6.98935 1.94783 6.08383 2.47328 5.31973C2.99873 4.55563 3.7436 3.96889 4.60951 3.63701C5.47542 3.30513 6.42164 3.24372 7.32318 3.46088C8.22473 3.67805 9.03919 4.16358 9.659 4.85335C9.70266 4.90002 9.75544 4.93724 9.81407 4.96268C9.8727 4.98812 9.93593 5.00125 9.99984 5.00125C10.0637 5.00125 10.127 4.98812 10.1856 4.96268C10.2442 4.93724 10.297 4.90002 10.3407 4.85335C10.9585 4.1591 11.7732 3.66949 12.6762 3.44968C13.5792 3.22988 14.5277 3.2903 15.3956 3.62292C16.2634 3.95553 17.0093 4.54456 17.5341 5.3116C18.0589 6.07864 18.3376 6.98731 18.3332 7.91668C18.3332 9.82501 17.0832 11.25 15.8332 12.5L11.2565 16.9275C11.1012 17.1059 10.9098 17.2491 10.6949 17.3478C10.48 17.4464 10.2465 17.4982 10.0101 17.4997C9.77362 17.5012 9.53954 17.4524 9.32341 17.3565C9.10728 17.2605 8.91403 17.1197 8.7565 16.9433L4.1665 12.5C2.9165 11.25 1.6665 9.83335 1.6665 7.91668Z" stroke="#F1684A" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>`;

  const buildClone = (original) => {
    const clone = document.createElement('a');
    clone.href = 'javascript:void(0)';
    clone.rel = 'nofollow';
    clone.setAttribute(cloneAttr, '');
    clone.classList.add(cloneClass);
    clone.setAttribute('aria-label', original.getAttribute('aria-label') || 'Add to wishlist');
    clone.setAttribute('title', original.getAttribute('title') || 'Add to wishlist');
    clone.setAttribute('data-added', original.getAttribute('data-added') || 'false');
    clone.innerHTML = heartSvg;
    clone.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      original.click();
    });
    return clone;
  };

  const standaloneClass = 'ag-pdp-wishlist-standalone';

  const relocate = () => {
    const original = document.querySelector(originalSelector);
    if (!original) return;

    const originalBlock = original.closest('.product-info-secondary');

    let target = document.querySelector(targetSelector);

    // Buy buttons block is absent — create a styled wrapper in its place.
    if (!target) {
      if (!document.querySelector(`.${standaloneClass}`)) {
        const wrapper = document.createElement('div');
        wrapper.classList.add('product-actions-add-to-cart', standaloneClass);
        if (originalBlock) {
          originalBlock.insertAdjacentElement('beforebegin', wrapper);
        } else {
          document.querySelector('.product-info')?.appendChild(wrapper);
        }
      }
      target = document.querySelector(`.${standaloneClass}`);
    }

    if (!target) return;

    if (originalBlock) originalBlock.style.setProperty('display', 'none', 'important');

    if (target.querySelector(`[${cloneAttr}]`)) return;

    const clone = buildClone(original);
    target.appendChild(clone);

    new MutationObserver(() => {
      const added = original.getAttribute('data-added');
      if (added !== null && clone.getAttribute('data-added') !== added) {
        clone.setAttribute('data-added', added);
      }
    }).observe(original, { attributes: true, attributeFilter: ['data-added'] });
  };

  const init = () => {
    relocate();
    requestAnimationFrame(relocate);
    setTimeout(relocate, 500);
    setTimeout(relocate, 1500);
    document.addEventListener('product:variant-change', () => {
      requestAnimationFrame(relocate);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
